<button
  [class]="buttonClasses"
  [style]="buttonStyles"
  [disabled]="disabled"
  [type]="type"
  (click)="onClick($event)"
  [class.active]="isActive"
  [style.font-family]="fontFamily"
>
  <ng-content></ng-content>
</button>
